import { render, staticRenderFns } from "./Crane.vue?vue&type=template&id=31d277f4"
import script from "./Crane.vue?vue&type=script&lang=js"
export * from "./Crane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports